/**
 * AllAll 图片：flux-pro-1.1-ultra
 * 参数与 flux-kontext-max / flux-kontext-pro / flux-schnell 一致
 */
import { buildBodyWithModel } from './utils'

export function buildBody(params) {
  return buildBodyWithModel('flux-pro-1.1-ultra', params)
}
